// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".create-sensor form .input-form-wrapper[data-v-33baaf42]{margin-bottom:16px}.create-sensor form .input-form-wrapper[data-v-33baaf42]:last-child{margin-bottom:0}.create-sensor form .input-form-wrapper label[data-v-33baaf42]{font-weight:700}.create-sensor form .input-form-wrapper input[data-v-33baaf42]{padding:6px 8px;width:100%;height:35px;-webkit-box-sizing:border-box;box-sizing:border-box;border:1px solid #ccc;border-radius:4px}", ""]);
// Exports
module.exports = exports;
